import { render, staticRenderFns } from "./modal_excluir_item_comanda_auditoria.vue?vue&type=template&id=120ffff3&scoped=true"
import script from "./modal_excluir_item_comanda_auditoria.vue?vue&type=script&lang=js"
export * from "./modal_excluir_item_comanda_auditoria.vue?vue&type=script&lang=js"
import style0 from "./modal_excluir_item_comanda_auditoria.vue?vue&type=style&index=0&id=120ffff3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120ffff3",
  null
  
)

export default component.exports